import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdBuildings_buildingId = z.any()
export type TagsGetMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof tagsGetMunicipalities_municipalityIdBuildings_buildingId>

export const paramsGetMunicipalities_municipalityIdBuildings_buildingId = z.object({ "municipalityId": z.string(), "buildingId": z.string() })
export type ParamsGetMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof paramsGetMunicipalities_municipalityIdBuildings_buildingId>

export const responseGetMunicipalities_municipalityIdBuildings_buildingId = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "municipalityId": z.string(), "address": z.string().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof responseGetMunicipalities_municipalityIdBuildings_buildingId>

interface IGetMunicipalities_municipalityIdBuildings_buildingId extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdBuildings_buildingId,
  params: ParamsGetMunicipalities_municipalityIdBuildings_buildingId,
  response: ResponseGetMunicipalities_municipalityIdBuildings_buildingId
}
export const tagsPatchMunicipalities_municipalityIdBuildings_buildingId = z.any()
export type TagsPatchMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof tagsPatchMunicipalities_municipalityIdBuildings_buildingId>

export const paramsPatchMunicipalities_municipalityIdBuildings_buildingId = z.object({ "municipalityId": z.string(), "buildingId": z.string() })
export type ParamsPatchMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof paramsPatchMunicipalities_municipalityIdBuildings_buildingId>

export const bodyPatchMunicipalities_municipalityIdBuildings_buildingId = z.object({ "name": z.string().optional(), "address": z.string().optional() })
export type BodyPatchMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof bodyPatchMunicipalities_municipalityIdBuildings_buildingId>

export const responsePatchMunicipalities_municipalityIdBuildings_buildingId = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "municipalityId": z.string(), "address": z.string().optional(), "createdAt": z.string().optional(), "updatedAt": z.string().optional(), "image": z.string().optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof responsePatchMunicipalities_municipalityIdBuildings_buildingId>

interface IPatchMunicipalities_municipalityIdBuildings_buildingId extends BaseMethodType {
  tags: TagsPatchMunicipalities_municipalityIdBuildings_buildingId,
  params: ParamsPatchMunicipalities_municipalityIdBuildings_buildingId,
  body: BodyPatchMunicipalities_municipalityIdBuildings_buildingId,
  response: ResponsePatchMunicipalities_municipalityIdBuildings_buildingId
}
export const tagsDeleteMunicipalities_municipalityIdBuildings_buildingId = z.any()
export type TagsDeleteMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof tagsDeleteMunicipalities_municipalityIdBuildings_buildingId>

export const paramsDeleteMunicipalities_municipalityIdBuildings_buildingId = z.object({ "municipalityId": z.string(), "buildingId": z.string() })
export type ParamsDeleteMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof paramsDeleteMunicipalities_municipalityIdBuildings_buildingId>

export const responseDeleteMunicipalities_municipalityIdBuildings_buildingId = z.object({ "payload": z.object({ "message": z.string() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseDeleteMunicipalities_municipalityIdBuildings_buildingId = z.infer<typeof responseDeleteMunicipalities_municipalityIdBuildings_buildingId>

interface IDeleteMunicipalities_municipalityIdBuildings_buildingId extends BaseMethodType {
  tags: TagsDeleteMunicipalities_municipalityIdBuildings_buildingId,
  params: ParamsDeleteMunicipalities_municipalityIdBuildings_buildingId,
  response: ResponseDeleteMunicipalities_municipalityIdBuildings_buildingId
}
export const URL = '/municipalities/:municipalityId/buildings/:buildingId'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdBuildings_buildingId,
    params: paramsGetMunicipalities_municipalityIdBuildings_buildingId,
    response: responseGetMunicipalities_municipalityIdBuildings_buildingId
  },
  patch: {
    tags: tagsPatchMunicipalities_municipalityIdBuildings_buildingId,
    params: paramsPatchMunicipalities_municipalityIdBuildings_buildingId,
    body: bodyPatchMunicipalities_municipalityIdBuildings_buildingId,
    response: responsePatchMunicipalities_municipalityIdBuildings_buildingId
  },
  delete: {
    tags: tagsDeleteMunicipalities_municipalityIdBuildings_buildingId,
    params: paramsDeleteMunicipalities_municipalityIdBuildings_buildingId,
    response: responseDeleteMunicipalities_municipalityIdBuildings_buildingId
  }
}
export interface Municipalities_municipalityIdBuildings_buildingId extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdBuildings_buildingId,
  patch: IPatchMunicipalities_municipalityIdBuildings_buildingId,
  delete: IDeleteMunicipalities_municipalityIdBuildings_buildingId
}